import { combineReducers } from "redux"
import profileReducer from "./profile/slice"
import authenticationReducer from "./authentication/slice"

const reducers = combineReducers({
    profile: profileReducer,
    authentication: authenticationReducer,
})

export default reducers
